import React from 'react';
import {ManageOrderProduct} from './sub-view/manage-order';
import {BusinessLayout} from 'components/layouts/business';

class MyBusinessManageOrderContainer extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <BusinessLayout active='my-business-orders'>
        <h1 className="user-header">Quản lý đơn hàng</h1>
        <ManageOrderProduct/>
      </BusinessLayout>
    );
  }
}

export default MyBusinessManageOrderContainer;



// WEBPACK FOOTER //
// ./components/my-business/MyBusinessManageOrderContainer.jsx